import React from 'react';
import img1 from '../images/research.jpg';
import img2 from '../images/stand.jpg';
import img3 from '../images/team.jpg';
import img4 from '../images/assur.jpg';

const Services = () => {
    return (
        <section id="services" className="bg-[#fafaf8]">
            <div className="max-w-[1600px] mx-auto px-6 lg:px-16 py-16 md:py-20" data-aos="fade-up">
                {/* Section header — eyebrow + headline (kept from the modern pass) */}
                <div className="max-w-3xl mb-12">
                    <div className="text-sm font-bold tracking-[0.22em] uppercase text-[#5b2a2a] mb-5 flex items-center gap-3">
                        <span className="w-10 h-[2px] bg-[#5b2a2a]"></span>
                        What We Offer
                    </div>
                    <h2 className="text-3xl md:text-4xl lg:text-[2.6rem] font-bold text-[#1f2937] tracking-tight leading-[1.15] mb-4">
                        Built for the textile industry, end&#8209;to&#8209;end.
                    </h2>
                    <p className="text-base md:text-lg text-[#4b5563] leading-relaxed max-w-2xl">
                        From advanced formulations to in-house quality control, every step is engineered to add measurable value to your manufacturing process.
                    </p>
                </div>

                {/* Original image-overlay tiles */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

                    <div className="relative group overflow-hidden rounded-xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl border border-gray-200">
                        <img alt="Chemical Formulations" className="w-full h-72 object-cover transition-transform duration-500 group-hover:scale-110" src={img1} />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent opacity-80 p-6 rounded-b-lg">
                            <h4 className="text-lg font-bold text-white mb-1">CHEMICAL FORMULATIONS</h4>
                            <p className="text-sm text-white">
                                We develop advanced chemical formulations that enhance textile manufacturing processes.
                            </p>
                        </div>
                    </div>

                    <div className="relative group overflow-hidden rounded-xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl border border-gray-200">
                        <img alt="Updated Industry Standards" className="w-full h-72 object-cover transition-transform duration-500 group-hover:scale-110" src={img2} />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent opacity-80 p-6 rounded-b-lg">
                            <h4 className="text-lg font-bold text-white mb-1">UPDATED STANDARDS</h4>
                            <p className="text-sm text-white">
                                We adhere to and continually update our practices to meet the highest textile industry standards.
                            </p>
                        </div>
                    </div>

                    <div className="relative group overflow-hidden rounded-xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl border border-gray-200">
                        <img alt="Dedicated Chemical Experts" className="w-full h-72 object-cover transition-transform duration-500 group-hover:scale-110" src={img3} />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent opacity-80 p-6 rounded-b-lg">
                            <h4 className="text-lg font-bold text-white mb-1">DEDICATED CHEMICAL EXPERTS</h4>
                            <p className="text-sm text-white">
                                Our team of experienced chemists and technologists is committed to delivering superior textile solutions.
                            </p>
                        </div>
                    </div>

                    <div className="relative group overflow-hidden rounded-xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl border border-gray-200">
                        <img alt="Rigorous Quality Control" className="w-full h-72 object-cover transition-transform duration-500 group-hover:scale-110" src={img4} />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent opacity-80 p-6 rounded-b-lg">
                            <h4 className="text-lg font-bold text-white mb-1">RIGOROUS QUALITY CONTROL</h4>
                            <p className="text-sm text-white">
                                Our rigorous quality control processes ensure that every product meets stringent industry standards.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default Services;